import { Box } from '@mui/material';
import { IconApproved, IconCancel } from 'assets/img';
import { useCompanyRelativePath } from 'ogp/hooks';
import { FormProvider, useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import { Header, LwButton, Page, Toolbox } from 'redesign';
import { routes } from 'Routes';
import { useAlert } from 'shared/components/alerts';
import { useCreateEmployee } from '../../hooks/use-create-employee';
import { EmployeeForm, EmployeeFormData } from '../employee-form/employee-form';

export const EmployeeCreate = () => {
  const formMethods = useForm<EmployeeFormData>();
  const navigate = useNavigate();
  const generatePath = useCompanyRelativePath();
  const { alertSuccess, alertError } = useAlert();
  const mutation = useCreateEmployee();

  const handleSubmit = () => {
    formMethods.handleSubmit((data) => {
      mutation.mutate(data, {
        onSuccess: (id) => {
          alertSuccess('Employee created successfully');
          navigate(generatePath(routes.EmployeeDetail, { id }));
        },
        onError: (e) => alertError(e),
      });
    })();
  };

  return (
    <Page
      header={<Header titleText={'Nieuwe werknemer'} />}
      toolbox={
        <Toolbox underline>
          <LwButton onClick={handleSubmit} iconColorMode="stroke" startIcon={<IconApproved />}>
            Maak aan
          </LwButton>
          <LwButton
            onClick={() => navigate(generatePath(routes.Workforce))}
            iconColorMode="fill"
            color="secondary"
            startIcon={<IconCancel />}
          >
            Annuleer
          </LwButton>
        </Toolbox>
      }
    >
      <Box width="100%">
        <FormProvider {...formMethods}>
          <EmployeeForm formState="create" />
        </FormProvider>
      </Box>
    </Page>
  );
};
